"use strict";
exports.__esModule = true;
exports.MarketValueAdjustmentQueueStatus = exports.ExternalTransferAssetTradingStatus = exports.ExternalTransferCashMovementStatus = exports.ExternalTransferSubAccountQueueStatus = exports.ExternalTransferQueueStatus = exports.FundMergerQueueStatus = exports.MoveTransactionQueueStatus = exports.AccountHoldingTankStatus = exports.AdvancedCorrectionTankStatus = exports.CashTransferHoldingTankStatus = exports.InvestmentUpdateHoldingTankStatus = exports.DepositRequestHoldingTankStatus = exports.FeeRequestTradingStatuses = exports.FeeRequestQueueStatuses = exports.FeeRequestSubAccountStatuses = exports.PlanLiquidationSubAccountHoldingTankStatus = exports.PlanLiquidationHoldingTankStatus = exports.FeeAllocationRequestHoldingTankStatus = exports.FeeRequestHoldingTankStatus = exports.TradeStatusQueueStatus = exports.CashInterestQueueStatus = exports.DividendActivityQueueStatus = exports.DisbursementRequestQueueStatus = exports.CorrectionByAmountHoldingTankStatus = exports.DistributionSubAccountStatus = exports.DistributionRequestHoldingTankStatus = exports.IndividualSubAccountOrderHoldingTankStatus = exports.ReversalHoldingTankStatus = exports.FlattenRequestHoldingTankStatus = exports.TradeRequestHoldingTankStatus = exports.AllocateDepositHoldingTankStatus = exports.InvestContributionHoldingTankStatus = void 0;
var InvestContributionHoldingTankStatus;
(function (InvestContributionHoldingTankStatus) {
    InvestContributionHoldingTankStatus["queued"] = "queued";
    InvestContributionHoldingTankStatus["advancedCorrectionQueued"] = "advancedCorrectionQueued";
    InvestContributionHoldingTankStatus["processed"] = "processed";
    InvestContributionHoldingTankStatus["finished"] = "finished";
    InvestContributionHoldingTankStatus["failed"] = "failed";
    InvestContributionHoldingTankStatus["deferred"] = "deferred";
    InvestContributionHoldingTankStatus["reversed"] = "reversed";
})(InvestContributionHoldingTankStatus = exports.InvestContributionHoldingTankStatus || (exports.InvestContributionHoldingTankStatus = {}));
var AllocateDepositHoldingTankStatus;
(function (AllocateDepositHoldingTankStatus) {
    AllocateDepositHoldingTankStatus["queued"] = "queued";
    AllocateDepositHoldingTankStatus["advancedCorrectionQueued"] = "advancedCorrectionQueued";
    AllocateDepositHoldingTankStatus["finished"] = "finished";
    AllocateDepositHoldingTankStatus["failed"] = "failed";
    AllocateDepositHoldingTankStatus["deferred"] = "deferred";
    AllocateDepositHoldingTankStatus["reversed"] = "reversed";
})(AllocateDepositHoldingTankStatus = exports.AllocateDepositHoldingTankStatus || (exports.AllocateDepositHoldingTankStatus = {}));
var TradeRequestHoldingTankStatus;
(function (TradeRequestHoldingTankStatus) {
    TradeRequestHoldingTankStatus["queued"] = "queued";
    TradeRequestHoldingTankStatus["advancedCorrectionQueued"] = "advancedCorrectionQueued";
    TradeRequestHoldingTankStatus["recalculateBuys"] = "recalculateBuys";
    TradeRequestHoldingTankStatus["processed"] = "processed";
    TradeRequestHoldingTankStatus["finished"] = "finished";
    TradeRequestHoldingTankStatus["failed"] = "failed";
    TradeRequestHoldingTankStatus["deferred"] = "deferred";
    TradeRequestHoldingTankStatus["reversed"] = "reversed";
})(TradeRequestHoldingTankStatus = exports.TradeRequestHoldingTankStatus || (exports.TradeRequestHoldingTankStatus = {}));
var FlattenRequestHoldingTankStatus;
(function (FlattenRequestHoldingTankStatus) {
    FlattenRequestHoldingTankStatus["queued"] = "queued";
    FlattenRequestHoldingTankStatus["processed"] = "processed";
    FlattenRequestHoldingTankStatus["finished"] = "finished";
    FlattenRequestHoldingTankStatus["failed"] = "failed";
    FlattenRequestHoldingTankStatus["deferred"] = "deferred";
    FlattenRequestHoldingTankStatus["reversed"] = "reversed";
})(FlattenRequestHoldingTankStatus = exports.FlattenRequestHoldingTankStatus || (exports.FlattenRequestHoldingTankStatus = {}));
var ReversalHoldingTankStatus;
(function (ReversalHoldingTankStatus) {
    ReversalHoldingTankStatus["queued"] = "queued";
    ReversalHoldingTankStatus["finished"] = "finished";
    ReversalHoldingTankStatus["failed"] = "failed";
})(ReversalHoldingTankStatus = exports.ReversalHoldingTankStatus || (exports.ReversalHoldingTankStatus = {}));
var IndividualSubAccountOrderHoldingTankStatus;
(function (IndividualSubAccountOrderHoldingTankStatus) {
    IndividualSubAccountOrderHoldingTankStatus["queued"] = "queued";
    IndividualSubAccountOrderHoldingTankStatus["processed"] = "processed";
    IndividualSubAccountOrderHoldingTankStatus["finished"] = "finished";
    IndividualSubAccountOrderHoldingTankStatus["failed"] = "failed";
    IndividualSubAccountOrderHoldingTankStatus["reversed"] = "reversed";
    IndividualSubAccountOrderHoldingTankStatus["deferred"] = "deferred";
})(IndividualSubAccountOrderHoldingTankStatus = exports.IndividualSubAccountOrderHoldingTankStatus || (exports.IndividualSubAccountOrderHoldingTankStatus = {}));
var DistributionRequestHoldingTankStatus;
(function (DistributionRequestHoldingTankStatus) {
    DistributionRequestHoldingTankStatus["queued"] = "queued";
    DistributionRequestHoldingTankStatus["processed"] = "processed";
    DistributionRequestHoldingTankStatus["failed"] = "failed";
    DistributionRequestHoldingTankStatus["deferred"] = "deferred";
    DistributionRequestHoldingTankStatus["disbursingQueued"] = "disbursingQueued";
    DistributionRequestHoldingTankStatus["disbursing"] = "disbursing";
    DistributionRequestHoldingTankStatus["disbursingFailed"] = "disbursingFailed";
    DistributionRequestHoldingTankStatus["finished"] = "finished";
    DistributionRequestHoldingTankStatus["partiallyReversed"] = "partiallyReversed";
    DistributionRequestHoldingTankStatus["reversed"] = "reversed";
})(DistributionRequestHoldingTankStatus = exports.DistributionRequestHoldingTankStatus || (exports.DistributionRequestHoldingTankStatus = {}));
var DistributionSubAccountStatus;
(function (DistributionSubAccountStatus) {
    DistributionSubAccountStatus["queued"] = "queued";
    DistributionSubAccountStatus["processed"] = "processed";
    DistributionSubAccountStatus["failed"] = "failed";
    DistributionSubAccountStatus["finished"] = "finished";
    DistributionSubAccountStatus["reversed"] = "reversed";
})(DistributionSubAccountStatus = exports.DistributionSubAccountStatus || (exports.DistributionSubAccountStatus = {}));
var CorrectionByAmountHoldingTankStatus;
(function (CorrectionByAmountHoldingTankStatus) {
    CorrectionByAmountHoldingTankStatus["queued"] = "queued";
    CorrectionByAmountHoldingTankStatus["processed"] = "processed";
    CorrectionByAmountHoldingTankStatus["withdrawalQueued"] = "withdrawalQueued";
    CorrectionByAmountHoldingTankStatus["withdrawalComplete"] = "withdrawalComplete";
    CorrectionByAmountHoldingTankStatus["finished"] = "finished";
    CorrectionByAmountHoldingTankStatus["failed"] = "failed";
})(CorrectionByAmountHoldingTankStatus = exports.CorrectionByAmountHoldingTankStatus || (exports.CorrectionByAmountHoldingTankStatus = {}));
var DisbursementRequestQueueStatus;
(function (DisbursementRequestQueueStatus) {
    DisbursementRequestQueueStatus["queued"] = "queued";
    DisbursementRequestQueueStatus["disbursing"] = "disbursing";
    DisbursementRequestQueueStatus["disbursementRejected"] = "disbursementRejected";
    DisbursementRequestQueueStatus["deferred"] = "deferred";
    DisbursementRequestQueueStatus["failed"] = "failed";
    DisbursementRequestQueueStatus["finished"] = "finished";
    DisbursementRequestQueueStatus["cancelled"] = "cancelled";
})(DisbursementRequestQueueStatus = exports.DisbursementRequestQueueStatus || (exports.DisbursementRequestQueueStatus = {}));
var DividendActivityQueueStatus;
(function (DividendActivityQueueStatus) {
    // queued is queued from NWDIVIDEND file
    DividendActivityQueueStatus["queued"] = "queued";
    DividendActivityQueueStatus["noDivDeclFound"] = "noDivDeclFound";
    DividendActivityQueueStatus["unhandled"] = "unhandled";
    DividendActivityQueueStatus["reversed"] = "reversed";
    DividendActivityQueueStatus["failed"] = "failed";
    DividendActivityQueueStatus["finished"] = "finished";
})(DividendActivityQueueStatus = exports.DividendActivityQueueStatus || (exports.DividendActivityQueueStatus = {}));
var CashInterestQueueStatus;
(function (CashInterestQueueStatus) {
    // queued is queued from BNY TranCode 399 BAI2 inbound file
    CashInterestQueueStatus["queued"] = "queued";
    CashInterestQueueStatus["advancedCorrectionQueued"] = "advancedCorrectionQueued";
    CashInterestQueueStatus["reversed"] = "reversed";
    CashInterestQueueStatus["failed"] = "failed";
    CashInterestQueueStatus["finished"] = "finished";
})(CashInterestQueueStatus = exports.CashInterestQueueStatus || (exports.CashInterestQueueStatus = {}));
var TradeStatusQueueStatus;
(function (TradeStatusQueueStatus) {
    TradeStatusQueueStatus["queued"] = "queued";
    TradeStatusQueueStatus["failed"] = "failed";
    TradeStatusQueueStatus["finished"] = "finished";
})(TradeStatusQueueStatus = exports.TradeStatusQueueStatus || (exports.TradeStatusQueueStatus = {}));
var FeeRequestHoldingTankStatus;
(function (FeeRequestHoldingTankStatus) {
    FeeRequestHoldingTankStatus["queued"] = "queued";
    FeeRequestHoldingTankStatus["processed"] = "processed";
    FeeRequestHoldingTankStatus["processingTrades"] = "processingTrades";
    FeeRequestHoldingTankStatus["pendingFeeTransfer"] = "pendingFeeTransfer";
    FeeRequestHoldingTankStatus["transferStarted"] = "transferStarted";
    FeeRequestHoldingTankStatus["transferFailed"] = "transferFailed";
    FeeRequestHoldingTankStatus["complete"] = "complete";
    FeeRequestHoldingTankStatus["deferred"] = "deferred";
    FeeRequestHoldingTankStatus["failed"] = "failed";
    FeeRequestHoldingTankStatus["reversed"] = "reversed";
    FeeRequestHoldingTankStatus["partiallyReversed"] = "partiallyReversed";
    FeeRequestHoldingTankStatus["depositOnly"] = "depositOnly";
})(FeeRequestHoldingTankStatus = exports.FeeRequestHoldingTankStatus || (exports.FeeRequestHoldingTankStatus = {}));
var FeeAllocationRequestHoldingTankStatus;
(function (FeeAllocationRequestHoldingTankStatus) {
    FeeAllocationRequestHoldingTankStatus["queued"] = "queued";
    FeeAllocationRequestHoldingTankStatus["processed"] = "processed";
    FeeAllocationRequestHoldingTankStatus["complete"] = "complete";
    FeeAllocationRequestHoldingTankStatus["failed"] = "failed";
})(FeeAllocationRequestHoldingTankStatus = exports.FeeAllocationRequestHoldingTankStatus || (exports.FeeAllocationRequestHoldingTankStatus = {}));
var PlanLiquidationHoldingTankStatus;
(function (PlanLiquidationHoldingTankStatus) {
    PlanLiquidationHoldingTankStatus["queued"] = "queued";
    PlanLiquidationHoldingTankStatus["liquidating"] = "liquidating";
    PlanLiquidationHoldingTankStatus["disbursingQueued"] = "disbursingQueued";
    PlanLiquidationHoldingTankStatus["disbursing"] = "disbursing";
    PlanLiquidationHoldingTankStatus["complete"] = "complete";
    PlanLiquidationHoldingTankStatus["deferred"] = "deferred";
    PlanLiquidationHoldingTankStatus["failed"] = "failed";
    PlanLiquidationHoldingTankStatus["disbursementRejected"] = "disbursementRejected";
    PlanLiquidationHoldingTankStatus["reversed"] = "reversed";
    PlanLiquidationHoldingTankStatus["partiallyReversed"] = "partiallyReversed";
    PlanLiquidationHoldingTankStatus["cashTransferPending"] = "cashTransferPending";
    PlanLiquidationHoldingTankStatus["cashTransferFailed"] = "cashTransferFailed";
})(PlanLiquidationHoldingTankStatus = exports.PlanLiquidationHoldingTankStatus || (exports.PlanLiquidationHoldingTankStatus = {}));
var PlanLiquidationSubAccountHoldingTankStatus;
(function (PlanLiquidationSubAccountHoldingTankStatus) {
    PlanLiquidationSubAccountHoldingTankStatus["queued"] = "queued";
    PlanLiquidationSubAccountHoldingTankStatus["processed"] = "processed";
    PlanLiquidationSubAccountHoldingTankStatus["cashTransferQueued"] = "cashTransferQueued";
    PlanLiquidationSubAccountHoldingTankStatus["complete"] = "complete";
    PlanLiquidationSubAccountHoldingTankStatus["deferred"] = "deferred";
    PlanLiquidationSubAccountHoldingTankStatus["failed"] = "failed";
    PlanLiquidationSubAccountHoldingTankStatus["reversed"] = "reversed";
})(PlanLiquidationSubAccountHoldingTankStatus = exports.PlanLiquidationSubAccountHoldingTankStatus || (exports.PlanLiquidationSubAccountHoldingTankStatus = {}));
exports.FeeRequestSubAccountStatuses = [FeeRequestHoldingTankStatus.queued, FeeRequestHoldingTankStatus.processed];
exports.FeeRequestQueueStatuses = [
    FeeRequestHoldingTankStatus.queued,
    FeeRequestHoldingTankStatus.processingTrades,
    FeeRequestHoldingTankStatus.pendingFeeTransfer,
    FeeRequestHoldingTankStatus.transferStarted,
];
exports.FeeRequestTradingStatuses = [
    FeeRequestHoldingTankStatus.queued,
    FeeRequestHoldingTankStatus.processingTrades,
];
var DepositRequestHoldingTankStatus;
(function (DepositRequestHoldingTankStatus) {
    DepositRequestHoldingTankStatus["queued"] = "queued";
    DepositRequestHoldingTankStatus["pendingAch"] = "pendingAch";
    DepositRequestHoldingTankStatus["processingAch"] = "processingAch";
    DepositRequestHoldingTankStatus["pendingCashTransfer"] = "pendingCashTransfer";
    DepositRequestHoldingTankStatus["cashTransferFailed"] = "cashTransferFailed";
    DepositRequestHoldingTankStatus["confirmedAch"] = "confirmedAch";
    DepositRequestHoldingTankStatus["confirmedFunding"] = "confirmedFunding";
    DepositRequestHoldingTankStatus["complete"] = "complete";
    DepositRequestHoldingTankStatus["deferred"] = "deferred";
    DepositRequestHoldingTankStatus["failed"] = "failed";
    DepositRequestHoldingTankStatus["rejected"] = "rejected";
})(DepositRequestHoldingTankStatus = exports.DepositRequestHoldingTankStatus || (exports.DepositRequestHoldingTankStatus = {}));
var InvestmentUpdateHoldingTankStatus;
(function (InvestmentUpdateHoldingTankStatus) {
    InvestmentUpdateHoldingTankStatus["queued"] = "queued";
    InvestmentUpdateHoldingTankStatus["pendingCustodianInvestmentUpdate"] = "pendingCustodianInvestmentUpdate";
    InvestmentUpdateHoldingTankStatus["investmentUpdateConfirmed"] = "investmentUpdateConfirmed";
    InvestmentUpdateHoldingTankStatus["complete"] = "complete";
    InvestmentUpdateHoldingTankStatus["deferred"] = "deferred";
    InvestmentUpdateHoldingTankStatus["failed"] = "failed";
    InvestmentUpdateHoldingTankStatus["rejected"] = "rejected";
})(InvestmentUpdateHoldingTankStatus = exports.InvestmentUpdateHoldingTankStatus || (exports.InvestmentUpdateHoldingTankStatus = {}));
var CashTransferHoldingTankStatus;
(function (CashTransferHoldingTankStatus) {
    CashTransferHoldingTankStatus["queued"] = "queued";
    CashTransferHoldingTankStatus["processed"] = "processed";
    CashTransferHoldingTankStatus["internalTransferFinished"] = "internalTransferFinished";
    CashTransferHoldingTankStatus["externalTransferFinished"] = "externalTransferFinished";
    CashTransferHoldingTankStatus["failed"] = "failed";
    CashTransferHoldingTankStatus["deferred"] = "deferred";
})(CashTransferHoldingTankStatus = exports.CashTransferHoldingTankStatus || (exports.CashTransferHoldingTankStatus = {}));
var AdvancedCorrectionTankStatus;
(function (AdvancedCorrectionTankStatus) {
    AdvancedCorrectionTankStatus["queued"] = "queued";
    AdvancedCorrectionTankStatus["failing"] = "failing";
    AdvancedCorrectionTankStatus["failed"] = "failed";
    AdvancedCorrectionTankStatus["deferred"] = "deferred";
    AdvancedCorrectionTankStatus["processed"] = "processed";
    AdvancedCorrectionTankStatus["finished"] = "finished";
    AdvancedCorrectionTankStatus["analysisFinished"] = "analysisFinished";
})(AdvancedCorrectionTankStatus = exports.AdvancedCorrectionTankStatus || (exports.AdvancedCorrectionTankStatus = {}));
var AccountHoldingTankStatus;
(function (AccountHoldingTankStatus) {
    AccountHoldingTankStatus["queued"] = "queued";
    AccountHoldingTankStatus["pendingCustodianAccount"] = "pendingCustodianAccount";
    AccountHoldingTankStatus["pendingCustodianUpdate"] = "pendingCustodianUpdate";
    AccountHoldingTankStatus["pendingComplete"] = "pendingComplete";
    AccountHoldingTankStatus["complete"] = "complete";
    AccountHoldingTankStatus["failed"] = "failed";
    AccountHoldingTankStatus["deferred"] = "deferred";
    AccountHoldingTankStatus["rejected"] = "rejected";
})(AccountHoldingTankStatus = exports.AccountHoldingTankStatus || (exports.AccountHoldingTankStatus = {}));
var MoveTransactionQueueStatus;
(function (MoveTransactionQueueStatus) {
    MoveTransactionQueueStatus["queued"] = "queued";
    MoveTransactionQueueStatus["failed"] = "failed";
    MoveTransactionQueueStatus["finished"] = "finished";
})(MoveTransactionQueueStatus = exports.MoveTransactionQueueStatus || (exports.MoveTransactionQueueStatus = {}));
var FundMergerQueueStatus;
(function (FundMergerQueueStatus) {
    FundMergerQueueStatus["queued"] = "queued";
    FundMergerQueueStatus["failed"] = "failed";
    FundMergerQueueStatus["finished"] = "finished";
})(FundMergerQueueStatus = exports.FundMergerQueueStatus || (exports.FundMergerQueueStatus = {}));
var ExternalTransferQueueStatus;
(function (ExternalTransferQueueStatus) {
    ExternalTransferQueueStatus["queued"] = "queued";
    ExternalTransferQueueStatus["processingExternalTrades"] = "processingExternalTrades";
    ExternalTransferQueueStatus["processingExternalTradesComplete"] = "processingExternalTradesComplete";
    ExternalTransferQueueStatus["processingTrades"] = "processingTrades";
    ExternalTransferQueueStatus["processingTradesComplete"] = "processingTradesComplete";
    ExternalTransferQueueStatus["failed"] = "failed";
    ExternalTransferQueueStatus["deferred"] = "deferred";
    ExternalTransferQueueStatus["finished"] = "finished";
    ExternalTransferQueueStatus["rejected"] = "rejected";
})(ExternalTransferQueueStatus = exports.ExternalTransferQueueStatus || (exports.ExternalTransferQueueStatus = {}));
// this is for tracking the overall transfer (from/to) status
var ExternalTransferSubAccountQueueStatus;
(function (ExternalTransferSubAccountQueueStatus) {
    ExternalTransferSubAccountQueueStatus["queued"] = "queued";
    ExternalTransferSubAccountQueueStatus["processingExternalTrades"] = "processingExternalTrades";
    ExternalTransferSubAccountQueueStatus["processingExternalTradesComplete"] = "processingExternalTradesComplete";
    ExternalTransferSubAccountQueueStatus["processingTrades"] = "processingTrades";
    ExternalTransferSubAccountQueueStatus["processingTradesComplete"] = "processingTradesComplete";
    ExternalTransferSubAccountQueueStatus["failed"] = "failed";
    ExternalTransferSubAccountQueueStatus["deferred"] = "deferred";
    ExternalTransferSubAccountQueueStatus["finished"] = "finished";
    ExternalTransferSubAccountQueueStatus["rejected"] = "rejected";
})(ExternalTransferSubAccountQueueStatus = exports.ExternalTransferSubAccountQueueStatus || (exports.ExternalTransferSubAccountQueueStatus = {}));
// this is for tracking the ExternalTransfer cash money movement flow
var ExternalTransferCashMovementStatus;
(function (ExternalTransferCashMovementStatus) {
    ExternalTransferCashMovementStatus["notStarted"] = "notStarted";
    ExternalTransferCashMovementStatus["processingCashMovement"] = "processingCashMovement";
    ExternalTransferCashMovementStatus["failed"] = "failed";
    ExternalTransferCashMovementStatus["rejected"] = "rejected";
    ExternalTransferCashMovementStatus["complete"] = "complete";
    ExternalTransferCashMovementStatus["finished"] = "finished";
})(ExternalTransferCashMovementStatus = exports.ExternalTransferCashMovementStatus || (exports.ExternalTransferCashMovementStatus = {}));
// this is for tracking the ExternalTransfer dummy cusip trading flow
var ExternalTransferAssetTradingStatus;
(function (ExternalTransferAssetTradingStatus) {
    ExternalTransferAssetTradingStatus["notStarted"] = "notStarted";
    ExternalTransferAssetTradingStatus["trading"] = "trading";
    ExternalTransferAssetTradingStatus["failed"] = "failed";
    ExternalTransferAssetTradingStatus["rejected"] = "rejected";
    ExternalTransferAssetTradingStatus["complete"] = "complete";
    ExternalTransferAssetTradingStatus["finished"] = "finished";
})(ExternalTransferAssetTradingStatus = exports.ExternalTransferAssetTradingStatus || (exports.ExternalTransferAssetTradingStatus = {}));
var MarketValueAdjustmentQueueStatus;
(function (MarketValueAdjustmentQueueStatus) {
    MarketValueAdjustmentQueueStatus["queued"] = "queued";
    MarketValueAdjustmentQueueStatus["failed"] = "failed";
    MarketValueAdjustmentQueueStatus["finished"] = "finished";
})(MarketValueAdjustmentQueueStatus = exports.MarketValueAdjustmentQueueStatus || (exports.MarketValueAdjustmentQueueStatus = {}));
